import React from "react";
import Style from "./SubscriptionText.module.scss";
import useSubscriptionText from "./useSubscriptionText";
import IkeaFamilyPlusText from "../IkeaFamilyPlusText";

const SubscriptionText = ({ getTextById }) => {
  const { basicData, rtl, t } = useSubscriptionText();

  return (
    <div className={`${Style.subscription} ${rtl}`}>
      {/* <h2 className={Style.title}>{getTextById(1)}</h2> */}
      <IkeaFamilyPlusText t={t} />
      <h2 className={`h2 ${Style.subtitle}`}>{getTextById(2)}</h2>
      {/* <p>{getTextById(3)}</p> */}
      <ul>
        <li>{getTextById(4)}</li>
        <li>{getTextById(5)}</li>
        <li>{getTextById(49)}</li>
      </ul>
      <p>{getTextById(50)}</p>

      <h2 className={`h2 ${Style.sm_title}`}>
        <span className={`${rtl ? Style.amount_ar : Style.amount}`}>
          <span>{getTextById(45)}</span>
          {basicData?.data?.amount && <span>{parseInt(basicData?.data?.amount)}</span>}
        </span>
        /{getTextById(42).toLowerCase()}
      </h2>
    </div>
  );
};

export default SubscriptionText;
